import { Paper } from '@mantine/core';
import cx from 'clsx';

import classes from './paper.module.css';

declare module '@mantine/core' {
	export interface PaperProps {
		variant?: 'selectable';
		/** Use when `variant` is `selectable` */
		'data-selected'?: boolean;
	}
}

export const PaperTheme = Paper.extend({
	classNames: (_theme, props, _ctx) => ({
		root: cx(classes.paper, props.variant === 'selectable' && classes.selectable),
	}),
});
